import { ApiEpBilling } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "ep.billing.feature_product";

type Request = NonNullable<Parameters<typeof ApiEpBilling.Feature.retrieve>[0]>;
type Response = Await<ReturnType<typeof ApiEpBilling.Feature.retrieve>>;

export const useQueryBillingFeatureProduct = (
  params: Request,
  options?: Omit<UseQueryOptions<Response>, "queryKey" | "queryFn">,
) =>
  useQuery<Response>(
    [KEY, params],
    () => ApiEpBilling.Feature.retrieve(params),
    options,
  );

useQueryBillingFeatureProduct.KEY = KEY;
